export type {
  TeachingPopoverFooterBaseProps as TeachingPopoverFooterProps,
  TeachingPopoverFooterBaseState as TeachingPopoverFooterState,
} from '@fluentui/react-teaching-popover';
